export default __webpack_public_path__ + "static/banner-four-shape5-cb63d0266f9056ac02785e03c7bb4ea6.png";